import { render, staticRenderFns } from "./NoPermissionTooltip.vue?vue&type=template&id=3ed1f850"
import script from "./NoPermissionTooltip.vue?vue&type=script&lang=js"
export * from "./NoPermissionTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed1f850')) {
      api.createRecord('3ed1f850', component.options)
    } else {
      api.reload('3ed1f850', component.options)
    }
    module.hot.accept("./NoPermissionTooltip.vue?vue&type=template&id=3ed1f850", function () {
      api.rerender('3ed1f850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/NoPermissionTooltip.vue"
export default component.exports